export const LOGBOOK_FILTERS = [
  {
    id: 0,
    name: 'region',
    label: 'region',
    storeName: 'regions',
    value: [],
    data: [],
    filterType: 'site',
  },
  {
    id: 1,
    name: 'site-types',
    label: 'site_types',
    storeName: 'siteTypes',
    value: [],
    data: [],
    filterType: 'site',
  },
  {
    id: 2,
    name: 'event-category',
    label: 'logbook_event_category',
    storeName: 'eventCategories',
    value: [],
    data: [],
    filterType: 'event',
  },
  {
    id: 3,
    name: 'event',
    label: 'event',
    storeName: 'events',
    value: [],
    data: [],
    filterType: 'event',
  },
  {
    id: 4,
    name: 'locus-group',
    label: 'locus_groups',
    storeName: 'locusGroups',
    value: [],
    data: [],
    filterType: 'event',
  },
  {
    id: 5,
    name: 'locus',
    label: 'locus',
    storeName: 'locuses',
    value: [],
    data: [],
    filterType: 'event',
  },
  {
    id: 6,
    name: 'data_fields',
    label: 'data_fields',
    storeName: 'dataFields',
    value: [],
    data: [
      {
        id: 2,
        name: 'Event Category',
        storeName: 'category',
        translateName: 'category',
        type: 'event',
      },
      {
        id: 7,
        name: 'Start Time',
        storeName: 'start_time',
        translateName: 'startTime',
      },
      {
        id: 8,
        name: 'End Time',
        storeName: 'end_time',
        translateName: 'endTime',
      },
      {
        id: 9,
        name: 'Updated by',
        storeName: 'updated_by',
        translateName: 'updatedBy',
        type: 'obj',
      },
      {
        id: 10,
        name: 'File Attachments',
        storeName: 'file',
        translateName: 'file',
        type: 'file',
      },
      {
        id: 11,
        name: 'Comments',
        storeName: 'comment',
        translateName: 'comment',
      },
      {
        id: 12,
        name: 'Update Time',
        storeName: 'date_updated',
        type: 'date_updated',
        translateName: 'dateUpdated',
      },
    ],
    filterType: 'event',
  },
]

export const PROFILE_LOGBOOK_FILTERS = {
  locusGroups: [],
  locuses: [],
  siteTypes: [],
  regions: [],
  site: null,
  dataFields: [],
  eventCategories: [],
  events: [],
  sorting: {},
  filterPanelOpen: false,
}

export const COMPULSORY_FIELDS = [
  {
    id: 1,
    name: 'Event Data',
    storeName: 'event_date',
    translateName: 'eventDate',
    type: 'event_data',
  },
  {
    id: 3,
    name: 'Locus Group',
    storeName: 'locus_group',
    translateName: 'locusGroup',
    type: 'obj',
  },
  {
    id: 4,
    name: 'Locus',
    storeName: 'locus',
    translateName: 'locus',
    type: 'obj',
  },
  {
    id: 5,
    name: 'Event',
    storeName: 'event',
    translateName: 'event',
    type: 'event',
  },
  {
    id: 6,
    name: 'Result',
    storeName: 'result',
    translateName: 'result',
    type: 'result',
  },
]
